import React from 'react'
import PropTypes from 'prop-types'
import { TabContent } from 'reactstrap'
import { MyTimesheet } from './my-timesheet'
import { TimesheetByProjects } from './timesheet-by-project'
import TimesheetStatus from './timesheet-status'
import { TimesheetApproval } from './timesheet-approval'

const Content = class extends React.Component {
  render() {
    const { props } = this
    return (
      <TabContent activeTab={ this.props.activeTab }>
        { this.props.activeTab === 1 && (
          <MyTimesheet
            isEdit={ props.isEdit }
            clickEdit={ props.clickEdit }
            timesheets={ props.timesheets }
            leaveTypes={ props.leaveTypes }
            saveMyTimesheet={ props.saveMyTimesheet }
            clickCancel={ props.clickCancel }
            authData={ props.authData }
            selectedDate={ props.selectedDate }
            searchTimesheet={ props.searchTimesheet }
            handleChangeSearch={ props.handleChangeSearch }
            dates={ props.dates }
            weekdates={ props.weekdates }
            activeTab={ props.activeTab }
            sumHoursByDate={ props.sumHoursByDate }
            maximumWorkingHoursPerDay={ props.maximumWorkingHoursPerDay }
            myProjects={ props.myProjects }
            locations={ props.locations }
            addTask={ props.addTask }
            deleteTask={ props.deleteTask }
            deleteProject={ props.deleteProject }
            holidays={ props.holidays }
            leaveRequests={ props.leaveRequests }
            compensateRequests={ props.compensateRequests }
            handleClickCell={ props.handleClickCell }
            handleInputMyTimesheet={ props.handleInputMyTimesheet }
            invalidList={ props.invalidList }
            editHour={ props.editHour }
            myTimesheet={ props.myTimesheet }
          />
        )}
        { this.props.activeTab === 2 && <TimesheetByProjects { ...this.props } /> }
        { this.props.activeTab === 3 && <TimesheetStatus { ...this.props } /> }
        { this.props.activeTab === 4 && <TimesheetApproval { ...this.props } /> }
      </TabContent>
    )
  }
}

Content.propTypes = {
  activeTab: PropTypes.number.isRequired,
}

export default Content



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/index.js